import React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Element from "@bappweb/element"
import "../assets/style.scss"

const LandingHeader = (props) => {
  const renderProductImage = () => {
    let filePath = ""
    if (props.cid === "motosiklet") {
      filePath = "./img/tasitkredisi/landing-tasit-kredisi-motosiklet.png"
    }
    return <Image path={filePath} className="landing-header-img landing-header-img-desktop" />
  }

  let headerTitle = "Taşıt Kredisi Hesaplama Aracı ve Başvurusu"
  let headerDescription = ""
  if (props.cid === "motosiklet") {
    headerTitle = `Hayalinizdeki motosiklet için krediniz Akbank'ta!`
    headerDescription = `Hemen kredinize başvurun, avantajlı faiz oranlarıyla yola çıkın.`
  }

  let headerClassContainer = "landing-header-container"
  let headerClassWrapper = "landing-header-text-wrapper "
  let headerClassText = "landing-header-text"
  let textPositionClassName = "text-on-right"

  if (props.cid === "motosiklet") {
    headerClassContainer = "landing-header-container landing-header-container-red"
    headerClassWrapper = "landing-header-text-wrapper landing-header-text-wrapper-cid "
    textPositionClassName = "text-on-left"
    headerClassText = `landing-header-text landing-header-text-cid`
  }

  return (
    <Block type="header" className={headerClassContainer}>
      <Block className={headerClassWrapper + textPositionClassName}>
        <Block className={headerClassText}>
          <Element type="h1" className="header-text1">
            {headerTitle}
          </Element>
          <Element type="p" className="header-text2">
            {headerDescription}
          </Element>
        </Block>
      </Block>
      { props.cid !== "motosiklet" && (
      <Image
        path={"./img/tasitkredisi/landing-header.png"}
        className="landing-header-img landing-header-img-desktop"
      />) }
      { props.cid !== "motosiklet" && (
      <Image
        path={"./img/tasitkredisi/landing-header-mobile.png"}
        className="landing-header-img landing-header-img-mobile"
      />) }
      {props.cid && renderProductImage()}
    </Block>
  )
}

export default LandingHeader
